import {
  AppDispatch,
  AppState,
  fullstorySelectors,
  NamedElementsRequestActions,
  namedElementsSelectors,
} from '@fullstory/redux';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

const { useElementsRequestState } = namedElementsSelectors;

export const useNamedElements = () => {
  const dispatch = useDispatch<AppDispatch>();
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const namedElements = useSelector(namedElementsSelectors.getAllNamedElements);
  const namedElementMatcher = useSelector((state: AppState) =>
    namedElementsSelectors.getNamedElementMatcher(state),
  );
  const requestState = useElementsRequestState();

  useEffect(() => {
    dispatch(NamedElementsRequestActions.getAllNamedElements(orgId));
  }, [dispatch, orgId]);

  return { ...requestState, namedElements, namedElementMatcher };
};
